module.exports = __webpack_public_path__ + "img/night_mode.766b44de.jpg";